(() => {
  if (customElements.get('kmn-shipping-bar')) return;

  class KmnShippingBar extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.debounced = () => {
        clearTimeout(this._t);
        this._t = setTimeout(() => this.refresh(), 300);
      };
      if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        this.unsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.debounced);
      }
      this.patchFetch();

      // 常時固定：sectionラッパーをsticky化し、実測の高さをCSS変数へ
      // （ヘッダーのスティッキー位置がこの値だけ下がる）
      const section = this.closest('.shopify-section');
      if (section) section.classList.add('kmn-ship-sticky-section');
      this.setHeightVar = () => {
        document.documentElement.style.setProperty('--kmn-ship-h', (this.offsetHeight || 0) + 'px');
      };
      this.setHeightVar();
      window.addEventListener('resize', this.setHeightVar);
    }

    disconnectedCallback() {
      if (this.unsubscriber) this.unsubscriber();
      if (this.setHeightVar) window.removeEventListener('resize', this.setHeightVar);
    }

    // Dawnのpubsubを通らないカート更新（他アプリ等）も拾う保険
    patchFetch() {
      if (window.__kmnCartFetchPatched) return;
      window.__kmnCartFetchPatched = true;
      const orig = window.fetch;
      const isCartUrl = (u) => typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u);
      window.fetch = function (...args) {
        const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        const promise = orig.apply(this, args);
        if (isCartUrl(url)) {
          promise
            .then(() => {
              document.querySelectorAll('kmn-shipping-bar').forEach((el) => el.debounced && el.debounced());
            })
            .catch(() => {});
        }
        return promise;
      };
    }

    refresh() {
      fetch(`/?sections=${this.sectionId}`)
        .then((r) => r.json())
        .then((data) => {
          const html = data[this.sectionId];
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-kmn-ship]');
          const current = this.querySelector('[data-kmn-ship]');
          if (!fresh) return;
          const oldFill = current && current.querySelector('.kmn-ship__fill');
          const oldWidth = oldFill ? oldFill.style.width : '0%';
          if (current) current.replaceWith(fresh);
          else this.appendChild(fresh);
          if (this.setHeightVar) this.setHeightVar();
          const newFill = fresh.querySelector('.kmn-ship__fill');
          if (newFill) {
            const target = newFill.style.width;
            newFill.style.width = oldWidth;
            setTimeout(() => {
              newFill.style.width = target;
            }, 60);
          }
        })
        .catch(() => {});
    }
  }

  customElements.define('kmn-shipping-bar', KmnShippingBar);
})();
